function initializeResilientzCarousel(container) {
  'use strict';
  const root = container.querySelector('[data-carousel]');
  if (!root || root.dataset.rzReady) return;
  root.dataset.rzReady = 'true';
  const cards = [...root.querySelectorAll('[data-slide]')];
  const picks = [...container.querySelectorAll('[data-pick]')];
  const count = container.querySelector('[data-count]');
  const status = container.querySelector('[data-status]');
  let active = 0;
  let start = null;
  const deck = root.querySelector('.rz-l-deck');
  function sizeDeck() {
    deck.style.height = `${cards[active].offsetHeight}px`;
  }
  function show(index, announce = true) {
    active = (index + cards.length) % cards.length;
    cards.forEach((card, i) => {
      const offset = (i - active + cards.length) % cards.length;
      card.dataset.position = offset === 0 ? 'active' : offset === 1 ? 'next' : offset === cards.length - 1 ? 'previous' : 'away';
      card.inert = i !== active;
      card.setAttribute('aria-hidden', String(i !== active));
    });
    picks.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
    count.textContent = String(active + 1).padStart(2, '0');
    requestAnimationFrame(sizeDeck);
    if (announce) status.textContent = `${cards[active].dataset.name}. ${active + 1} of ${cards.length}.`;
  }
  root.closest('.rz-landing').classList.add('rz-l-carousel-ready');
  show(0, false);
  if (typeof ResizeObserver !== 'undefined') {
    const observer = new ResizeObserver(sizeDeck);
    cards.forEach(card => observer.observe(card));
  }
  window.addEventListener('resize', sizeDeck);
  container.querySelector('[data-prev]').addEventListener('click', () => show(active - 1));
  container.querySelector('[data-next]').addEventListener('click', () => show(active + 1));
  picks.forEach((button, i) => button.addEventListener('click', () => {
    show(i);
    if (window.matchMedia('(max-width: 800px)').matches) {
      root.scrollIntoView({block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
  }));
  root.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    const wasInside = cards[active].contains(document.activeElement);
    show(active + (event.key === 'ArrowRight' ? 1 : -1));
    if (wasInside) cards[active].querySelector('a').focus({preventScroll: true});
  });
  root.addEventListener('touchstart', event => {
    if (event.touches.length !== 1) return;
    start = {x: event.touches[0].clientX, y: event.touches[0].clientY};
  }, {passive: true});
  root.addEventListener('touchend', event => {
    if (!start) return;
    const dx = event.changedTouches[0].clientX - start.x;
    const dy = event.changedTouches[0].clientY - start.y;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) show(active + (dx < 0 ? 1 : -1));
    start = null;
  }, {passive: true});
  root.addEventListener('touchcancel', () => { start = null; }, {passive: true});
  const menuButton = container.querySelector('[data-menu]');
  const menu = container.querySelector('[data-mobile-nav]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const expanded = menuButton.getAttribute('aria-expanded') !== 'true';
      menuButton.setAttribute('aria-expanded', String(expanded));
      menu.hidden = !expanded;
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      menu.hidden = true;
      menuButton.setAttribute('aria-expanded', 'false');
    }));
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) {
        menu.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.focus();
      }
    });
  }
}
initializeResilientzCarousel(document);
document.addEventListener('shopify:section:load', event => initializeResilientzCarousel(event.target));
